
import { RESET_ANALYTICS_FILTER, SET_ANALYTICS_FILTER } from "../types";

const initialState = {
    dateRange: [null, null],
    selectedOption: [],
};

const analyticsFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ANALYTICS_FILTER:
            return {
                ...state,
                dateRange: action.payload.dateRange,
                selectedOption: action.payload.selectedOption,
            };
        case RESET_ANALYTICS_FILTER:
            return {
                ...state,
                selectedOption: [],
            };
        default:
            return state;
    }
};

export default analyticsFilterReducer;
